module.exports = __webpack_public_path__ + "media/images/illustration_2_764-ae41c5344a4b1427c1f0d5c10e83a22c.png";